export const organizationsList = {
  WAFFY_ORGANIZATIONS: "منظمات وفّي",
  ORGANIZATIONS_LIST: "قائمة الشركات",
  CODE: "كود",
  NAME: "إسم",
  FEES: "رسوم",
  LOGO: "لوجو",
  WEBSITE_URL: "لينك الموقع",
  DESCRIPTIONS: "تفاصيل",
  ADD_ORGANIZATION: "إضافة شركة",
  EDIT_ORGANIZATION: "تعديل الشركة",
  FIND_A_ORGANIZATION: "… اﺑﺤﺚ ﻋﻦ شركة",
  ADD_A_ORGANIZATION: "إضافة",
  EDIT_A_ORGANIZATION: "تعديل",
};
